// extracted by mini-css-extract-plugin
export var dividerLine = "_43-0";
export var errorBackground = "_43-1";